// frontend/src/core/auth/usePermission.ts
//
// Tenant-user permission gating for UI controls. The permission set comes
// from GET /api/auth/me (see AuthProvider): non-owners get their distinct
// granted keys; owners get the ['*'] wildcard, which mirrors the backend's
// owner fast-pass in requirePermission — `usePermission(anything)` is true
// for owners.
//
// These hooks gate VISIBILITY only. The server-side requirePermission
// middleware remains the actual enforcement — never rely on this for
// security, only to stop rendering controls that would 403 on click.

import { useAuth } from './AuthProvider';

/** Raw permission set from /me. Empty while logged out; `'*'` = universal. */
export function usePermissions(): Set<string> {
  return useAuth().permissions;
}

/** True when the current user holds `key` (or the `'*'` owner wildcard). */
export function usePermission(key: string): boolean {
  const perms = usePermissions();
  return perms.has('*') || perms.has(key);
}
